import { ResponseMessage, DisplayName, CreationInfo, ModifyInfo, IdVersion, Column } from './common';

export type RootState = {
    working: boolean;
    applicationMessage: ResponseMessage | null;
    loggedUser: UtenteLoginModel | null;
    drawer: boolean;
    drawerMini: boolean;
}

export type UtenteLoginModel = {
    id: number;
    username: string;
    tipoUtenteId: number;
    tipoUtente: string;
    dataUltimoLogin: Date;
    passwordScaduta: boolean;
    token: string;
}

export type Utente = {
    username: string;
    nome: string;
    cognome: string;
    tipoUtenteId: number;
    attivo: boolean;
    isPasswordScaduta: boolean;
    dataUltimoLogin: Date | null;
} & IdVersion & CreationInfo & ModifyInfo & DisplayName

export type Attributo = {
    tipo: string;
    descrizione: string;
    valore: string;
} & IdVersion & CreationInfo & ModifyInfo & DisplayName

export type AttributoList = {
    tipo: string;
    descrizione: string;
} & IdVersion & DisplayName

export type AttributoEditViewModel = {
    item: Attributo | null;
    isValid: boolean;
}

export type AttributoListViewModel = {
    columns: Column[];
    dataItems: AttributoList[];
    search: string;
    selectedItems: AttributoList[];
    tipo: string;
}
export type PrestazioneList = {
    dataEvento: Date;
    avvocato: string;
    utente: string;
    ultimoStato: string;
    paziente: string;
} & IdVersion & CreationInfo & ModifyInfo

export type PrestazioneDashboard = {
    id: number;
    descrizione: string;
    numero: number;
}

export type Prestazione = {
    avvocatoId: number;
    utenteId: number;
    ultimoStatoId: number;
    enteSanitarioId?: number;
    enteSanitarioPercentuale?: number;
    compagniaAssicurativaId?: number;
    compagniaAssicurativaPercentuale?: number;
    operatoreSanitarioId?: number;
    operatoreSanitarioPercentuale?: number;
    pazienteId: number;
    dataEvento: Date;
    dataRichiestaRisarcimentoDanni?: Date;
    consulenteTecnicoParte: string;
    enteSanitarioUnitaOperativa: string;
    dannoLamentato: string;
    dannoLamentatoPercentuale?: number;
    dannoLamentatoImporto?: number;
    procedimentoPenale: boolean;
    tipoProcedimentoPenaleId?: number;
    procedimentoPenaleDataOperazioniPeriteriali?: Date;
    procedimentoPenaleNotePreBozza: string;
    procedimentoPenaleDataRicevimentoBozza?: Date;
    procedimentoPenaleDataScadenzaOsservazioni?: Date;
    procedimentoPenaleDataDepositoDefinitiva?: Date;
    procedimentoCivile: boolean;
    tipoProcedimentoCivileId?: number;
    procedimentoCivileDataOperazioniPeriteriali?: Date;
    procedimentoCivileNotePreBozza: string;
    procedimentoCivileDataRicevimentoBozza?: Date;
    procedimentoCivileDataScadenzaOsservazioni?: Date;
    procedimentoCivileDataDepositoDefinitiva?: Date;
    conciliazione: string;
    dataScadenzaAdesione?: Date;
    enteSanitarioRiservaImporto?: number;
    compagniaAssicuativaRiservaImporto?: number;
    notePrestazione: string;
    periziando: boolean;
    ctuPresenti: string;
    ctpAttorei: string;
    ctpAltriConvenuti: string;
    dataUlterioreConvocazione?: Date;
    dataNotePrebozzaEntro?: Date;
    dataPromemoria?: Date;
    notePromemoria: string;
    giorniScadenzaPromemoria?: number;
    hasRelazioneMedica?: boolean;
} & IdVersion & CreationInfo & ModifyInfo & DisplayName

export type DashboardViewModel = {
    items: PrestazioneDashboard[];
}

export type PrestazioniViewModel = {
    columns: Column[];
    dataItems: PrestazioneList[];
    search: string;
    selectedItems: PrestazioneList[];
}

export type PrestazioneDetailViewModel = {
    item: Prestazione | null;
    isValid: boolean;
    hasRelazioneMedica: boolean;
    panels: any[];
    isRelazioneValid: boolean;
    statoLogDialog: boolean;
    showPrestazionePrint: boolean;
    selectedTab: any;
    prossimoStatoId: number | null;
}

export type LoginViewModel = {
    username: string | null;
    password: string | null;
    isValid: boolean;
    viewType: LoginViewType;
    oldPassword: string | null;
    newPassword: string | null;
    passwordConfirmation: string | null;
}

export enum LoginViewType {
    login,
    passwordScaduta,
    recuperaPassword
}

export type UtenteList = {
    username: string;
    tipoUtente: string;
    dataUltimoLogin?: Date;
    passwordScaduta: boolean;
    attivo: boolean;
} & IdVersion & CreationInfo & ModifyInfo

export type UtenteListViewModel = {
    columns: Column[];
    dataItems: UtenteList[];
    search: string;
    selectedItems: UtenteList[];
}

export type UtenteDetailViewModel = {
    item: Utente | null;
    isValid: boolean;
}

export type AvvocatoListViewModel = {
    columns: Column[];
    dataItems: AvvocatoList[];
    search: string;
    selectedItems: AvvocatoList[];
}

export type AvvocatoList = {
    nome: string;
    cognome: string;
    email: string;
} & IdVersion & DisplayName

export type Avvocato = {
    nome: string;
    cognome: string;
    email: string;
    attivo: boolean;
} & IdVersion & CreationInfo & ModifyInfo & DisplayName

export type AvvocatoEditViewModel = {
    item: Avvocato | null;
    isValid: boolean;
}

export type EnteSanitarioList = {
    descrizione: string;
} & IdVersion & DisplayName

export type EnteSanitario = {
    descrizione: string;
    attivo: boolean;
} & IdVersion & CreationInfo & ModifyInfo & DisplayName

export type EnteSanitarioEditViewModel = {
    item: EnteSanitario | null;
    isValid: boolean;
}

export type EnteSanitarioListViewModel = {
    columns: Column[];
    dataItems: EnteSanitarioList[];
    search: string;
    selectedItems: EnteSanitarioList[];
}

export type CompagniaAssicurativaListViewModel = {
    columns: Column[];
    dataItems: CompagniaAssicurativaList[];
    search: string;
    selectedItems: CompagniaAssicurativaList[];
}

export type CompagniaAssicurativaList = {
    descrizione: string;
} & IdVersion & DisplayName

export type CompagniaAssicurativa = {
    descrizione: string;
    attivo: boolean;
} & IdVersion & CreationInfo & ModifyInfo & DisplayName

export type CompagniaAssicurativaEditViewModel = {
    item: CompagniaAssicurativa | null;
    isValid: boolean;
}

export type OperatoreSanitarioListViewModel = {
    columns: Column[];
    dataItems: OperatoreSanitarioList[];
    search: string;
    selectedItems: OperatoreSanitarioList[];

}
export type OperatoreSanitarioList = {
    nome: string;
    cognome: string;
    qualifica: string;
} & IdVersion & DisplayName

export type OperatoreSanitario = {
    nome: string;
    cognome: string;
    qualificaId: number;
    entiSanitariId: number[] | null;
    attivo: boolean;
} & IdVersion & CreationInfo & ModifyInfo & DisplayName

export type OperatoreSanitarioEditViewModel = {
    item: OperatoreSanitario | null;
    isValid: boolean;
}

export type PazienteListViewModel = {
    columns: Column[];
    dataItems: PazienteList[];
    search: string;
    selectedItems: PazienteList[];

}

export type PazienteList = {
    nome: string;
    cognome: string;
    codiceFiscale: string;
} & IdVersion & DisplayName

export type Paziente = {
    tipoDocumentoId?: number;
    nascitaProvinciaId?: number;
    sessoId: number;
    residenzaProvinciaId?: number;
    documentoProvinciaId?: number;
    ProfessioneId?: number;
    nome: string;
    cognome: string;
    codiceFiscale: string;
    dataDiNascita?: Date;
    indirizzo: string;
    numeroDocumento: string;
    dataDocumento?: Date;
    attivo: boolean;
} & IdVersion & CreationInfo & ModifyInfo & DisplayName

export type PazienteEditViewModel = {
    item: Paziente | null;
    isValid: boolean;
}

export type RichiedenteListViewModel = {
    columns: Column[];
    dataItems: RichiedenteList[];
    search: string;
    selectedItems: RichiedenteList[];

}
export type RichiedenteList = {
    nome: string;
    cognome: string;
} & IdVersion & DisplayName

export type Richiedente = {
    nome: string;
    cognome: string;
    attivo: boolean;
} & IdVersion & CreationInfo & ModifyInfo & DisplayName

export type RichiedenteEditViewModel = {
    item: Richiedente | null;
    isValid: boolean;
}

export type RelazioneMedica = {
    prestazioneId: number;
    operatoreSanitarioId: number;
    utenteId: number;
    tipoIncaricoId: number;
    tipoRelazioneId: number;
    dataVisita?: Date;
    personePresentiVisita?: string;
    documentazioneVisita?: string;
    relazioneDiParte: boolean;
    relazioneDiParteRedattaDa?: string;
    relazioneSpecialistica: boolean;
    relazioneSpecialisticaRedattaDa?: string;
    contestazioniControparte?: string;
    nessoCausale: boolean;
    perditaChance: boolean;
    perditaChancePercentuale?: number;
    invaliditaPermanenteBase?: number;
    invaliditaPermanenteDifferenziale?: number;
    invaliditaPermanenteComplessiva?: number;
    inabilitaTemporaneaTotale?: number;
    inabilitaTemporaneaParzialePercentuale?: number;
    inabilitaTemporaneaParzialeGiorni?: number;
    precedentiAnamnestici?: string;
    esameObiettivo: string;
    consulenzaTecnicaTribunale?: string;
    consulenzaTecnicaRelatore?: string;
    consulenzaTecnicaConclusioni?: string;
    sintesiCriticita?: string;
    considerazioniMedicoLegali?: string;
    responsabilitaTotalmenteImpegnata?: boolean;
    responsabilitaNonImpegnata?: boolean;
    assenzaDiNesso?: boolean;
    responsabilitaParzialmenteImpegnata?: boolean;
    responsabilitaParzialmenteImpegnataPercentuale?: number;
    responsabilitaNonAssicurati?: boolean;
    nessoCausaleInterno: boolean;
    perditaChanceInterno: boolean;
    perditaChancePercentualeInterno?: number;
    invaliditaPermanenteBaseInterno?: number;
    invaliditaPermanenteDifferenzialeInterno?: number;
    invaliditaPermanenteComplessivaInterno?: number;
    inabilitaTemporaneaTotaleInterno?: number;
    inabilitaTemporaneaParzialePercentualeInterno?: number;
    inabilitaTemporaneaParzialeGiorniInterno?: number;
    richiestaUlterioreDocumentazioneControparte?: boolean;
    richiestaRelazioneSanitari?: boolean;
    richiestaRelazioneParte?: boolean;
    richiestaVisita?: boolean;
    richiestiUlterioriAccertamenti?: boolean;
    richiestoSupportoSpecialistico?: boolean;
    richiestoAltro?: boolean;
    noteRichieste: string;
    prestazione?: Prestazione;
    relazioniSanitari?: RelazioneMedicaRelazioneSanitario[];
    responsabilitaAssicurato?: RelazioneMedicaResponsabilita[];
    responsabilitaNonAssicurato?: RelazioneMedicaResponsabilita[];
    spese?: RelazioneMedicaSpesa[];
} & IdVersion & CreationInfo & ModifyInfo & DisplayName

export type RelazioneMedicaList = {
    tipo: string;
    descrizione: string;
} & IdVersion & DisplayName

export type RelazioneMedicaEditViewModel = {
    item: RelazioneMedica | null;
    isValid: boolean;
    panels: number[];
    showPrint: boolean;
}

export type RelazioneMedicaEventoListViewModel = {
    columns: Column[];
    dataItems: RelazioneMedicaEvento[];
    selectedItems: RelazioneMedicaEvento[];
    dialog: boolean;
    editComponent: any;
    currentEditId?: number;
}

export type RelazioneMedicaEvento = {
    dataEvento: Date;
    note: string;
    relazioneMedicaId: number;
} & IdVersion & CreationInfo & ModifyInfo

export type RelazioneMedicaEventoEditViewModel = {
    item: RelazioneMedicaEvento | null;
    isValid: boolean;
}

export type RelazioneMedicaRelazioneSanitario = {
    operatoreSanitarioId: number;
    relazione: string;
    relazioneMedicaId: number;
} & IdVersion & CreationInfo & ModifyInfo

export type RelazioneMedicaRelazioneSanitarioEditViewModel = {
    item: RelazioneMedicaRelazioneSanitario | null;
    isValid: boolean;
}

export type RelazioneMedicaRelazioneSanitarioListViewModel = {
    columns: Column[];
    dataItems: RelazioneMedicaRelazioneSanitario[];
    selectedItems: RelazioneMedicaRelazioneSanitario[];
    dialog: boolean;
    editComponent: any;
    currentEditId?: number;
}

export type RelazioneMedicaResponsabilita = {
    operatoreSanitarioId: number;
    percentualeResponsabilita: number;
    assicurato: boolean;
    relazioneMedicaId: number;
} & IdVersion & CreationInfo & ModifyInfo

export type RelazioneMedicaResponsabilitaEditViewModel = {
    item: RelazioneMedicaResponsabilita | null;
    isValid: boolean;
}

export type RelazioneMedicaResponsabilitaListViewModel = {
    columns: Column[];
    dataItems: RelazioneMedicaResponsabilita[];
    selectedItems: RelazioneMedicaResponsabilita[];
    dialog: boolean;
    editComponent: any;
    currentEditId?: number;
}

export type RelazioneMedicaSpesaListViewModel = {
    columns: Column[];
    dataItems: RelazioneMedicaSpesa[];
    selectedItems: RelazioneMedicaSpesa[];
    dialog: boolean;
    editComponent: any;
    currentEditId?: number;
}

export type RelazioneMedicaSpesa = {
    importo: number;
    note: string;
    relazioneMedicaId: number;
} & IdVersion & CreationInfo & ModifyInfo

export type RelazioneMedicaSpesaEditViewModel = {
    item: RelazioneMedicaSpesa | null;
    isValid: boolean;
}

export enum StatoPrestazioneEnum {
    InseritaId = 1,
    PresaInCaricoId = 2,
    PassataAlMedicoId = 3,
    TerminataId = 6
}

export type PrestazioneLogStatoViewModel = {
    isOpen: boolean;
    note: string;
}

export type TipoAttributo = {
    id: string;
} & DisplayName